// Credit: https://gist.githubusercontent.com/revolunet/6173043/raw/222c4537affb1bdecbabcec51143742709aa0b6e/countries-FR.json
export const countries = [
  {
    "label": "Afghanistan",
    "value": "AF",
    "dialCode": "93"
  },
  {
    "label": "Afrique du Sud",
    "value": "ZA",
    "dialCode": "27"
  },
  {
    "label": "Albanie",
    "value": "AL",
    "dialCode": "355"
  },
  {
    "label": "Algérie",
    "value": "DZ",
    "dialCode": "213"
  },
  {
    "label": "Allemagne",
    "value": "DE",
    "dialCode": "49"
  },
  {
    "label": "Andorre",
    "value": "AD",
    "dialCode": "376"
  },
  {
    "label": "Angola",
    "value": "AO",
    "dialCode": "244"
  },
  {
    "label": "Anguilla",
    "value": "AI",
    "dialCode": "1"
  },
  {
    "label": "Antarctique",
    "value": "AQ"
  },
  {
    "label": "Antigua-et-Barbuda",
    "value": "AG",
    "dialCode": "1"
  },
  {
    "label": "Antilles néerlandaises",
    "value": "AN"
  },
  {
    "label": "Arabie saoudite",
    "value": "SA",
    "dialCode": "966"
  },
  {
    "label": "Argentine",
    "value": "AR",
    "dialCode": "54"
  },
  {
    "label": "Arménie",
    "value": "AM",
    "dialCode": "374"
  },
  {
    "label": "Aruba",
    "value": "AW",
    "dialCode": "297"
  },
  {
    "label": "Australie",
    "value": "AU",
    "dialCode": "61"
  },
  {
    "label": "Autriche",
    "value": "AT",
    "dialCode": "43"
  },
  {
    "label": "Azerbaïdjan",
    "value": "AZ",
    "dialCode": "994"
  },
  {
    "label": "Bahamas",
    "value": "BS",
    "dialCode": "1"
  },
  {
    "label": "Bahreïn",
    "value": "BH",
    "dialCode": "973"
  },
  {
    "label": "Bangladesh",
    "value": "BD",
    "dialCode": "880"
  },
  {
    "label": "Barbade",
    "value": "BB",
    "dialCode": "1"
  },
  {
    "label": "Bélarus",
    "value": "BY",
    "dialCode": "375"
  },
  {
    "label": "Belgique",
    "value": "BE",
    "dialCode": "32"
  },
  {
    "label": "Belize",
    "value": "BZ",
    "dialCode": "501"
  },
  {
    "label": "Bénin",
    "value": "BJ",
    "dialCode": "229"
  },
  {
    "label": "Bermudes",
    "value": "BM",
    "dialCode": "1"
  },
  {
    "label": "Bhoutan",
    "value": "BT",
    "dialCode": "975"
  },
  {
    "label": "Bolivie",
    "value": "BO",
    "dialCode": "591"
  },
  {
    "label": "Bosnie-Herzégovine",
    "value": "BA",
    "dialCode": "387"
  },
  {
    "label": "Botswana",
    "value": "BW",
    "dialCode": "267"
  },
  {
    "label": "Brésil",
    "value": "BR",
    "dialCode": "55"
  },
  {
    "label": "Brunéi Darussalam",
    "value": "BN",
    "dialCode": "673"
  },
  {
    "label": "Bulgarie",
    "value": "BG",
    "dialCode": "359"
  },
  {
    "label": "Burkina Faso",
    "value": "BF",
    "dialCode": "226"
  },
  {
    "label": "Burundi",
    "value": "BI",
    "dialCode": "257"
  },
  {
    "label": "Cambodge",
    "value": "KH",
    "dialCode": "855"
  },
  {
    "label": "Cameroun",
    "value": "CM",
    "dialCode": "237"
  },
  {
    "label": "Canada",
    "value": "CA",
    "dialCode": "1"
  },
  {
    "label": "Cap-Vert",
    "value": "CV",
    "dialCode": "238"
  },
  {
    "label": "Ceuta et Melilla",
    "value": "EA"
  },
  {
    "label": "Chili",
    "value": "CL",
    "dialCode": "56"
  },
  {
    "label": "Chine",
    "value": "CN",
    "dialCode": "86"
  },
  {
    "label": "Chypre",
    "value": "CY",
    "dialCode": "357"
  },
  {
    "label": "Colombie",
    "value": "CO",
    "dialCode": "57"
  },
  {
    "label": "Comores",
    "value": "KM",
    "dialCode": "269"
  },
  {
    "label": "Congo-Brazzaville",
    "value": "CG",
    "dialCode": "242"
  },
  {
    "label": "Corée du Nord",
    "value": "KP",
    "dialCode": "850"
  },
  {
    "label": "Corée du Sud",
    "value": "KR",
    "dialCode": "82"
  },
  {
    "label": "Costa Rica",
    "value": "CR",
    "dialCode": "506"
  },
  {
    "label": "Côte d’Ivoire",
    "value": "CI",
    "dialCode": "225"
  },
  {
    "label": "Croatie",
    "value": "HR",
    "dialCode": "385"
  },
  {
    "label": "Cuba",
    "value": "CU",
    "dialCode": "53"
  },
  {
    "label": "Danemark",
    "value": "DK",
    "dialCode": "45"
  },
  {
    "label": "Diego Garcia",
    "value": "DG"
  },
  {
    "label": "Djibouti",
    "value": "DJ",
    "dialCode": "253"
  },
  {
    "label": "Dominique",
    "value": "DM",
    "dialCode": "1"
  },
  {
    "label": "Égypte",
    "value": "EG",
    "dialCode": "20"
  },
  {
    "label": "El Salvador",
    "value": "SV",
    "dialCode": "503"
  },
  {
    "label": "Émirats arabes unis",
    "value": "AE",
    "dialCode": "971"
  },
  {
    "label": "Équateur",
    "value": "EC",
    "dialCode": "593"
  },
  {
    "label": "Érythrée",
    "value": "ER",
    "dialCode": "291"
  },
  {
    "label": "Espagne",
    "value": "ES",
    "dialCode": "34"
  },
  {
    "label": "Estonie",
    "value": "EE",
    "dialCode": "372"
  },
  {
    "label": "État de la Cité du Vatican",
    "value": "VA",
    "dialCode": "39"
  },
  {
    "label": "États fédérés de Micronésie",
    "value": "FM",
    "dialCode": "691"
  },
  {
    "label": "États-Unis",
    "value": "US",
    "dialCode": "1"
  },
  {
    "label": "Éthiopie",
    "value": "ET",
    "dialCode": "251"
  },
  {
    "label": "Fidji",
    "value": "FJ",
    "dialCode": "679"
  },
  {
    "label": "Finlande",
    "value": "FI",
    "dialCode": "358"
  },
  {
    "label": "France",
    "value": "FR",
    "dialCode": "33"
  },
  {
    "label": "Gabon",
    "value": "GA",
    "dialCode": "241"
  },
  {
    "label": "Gambie",
    "value": "GM",
    "dialCode": "220"
  },
  {
    "label": "Géorgie",
    "value": "GE",
    "dialCode": "995"
  },
  {
    "label": "Géorgie du Sud et les îles Sandwich du Sud",
    "value": "GS"
  },
  {
    "label": "Ghana",
    "value": "GH",
    "dialCode": "233"
  },
  {
    "label": "Gibraltar",
    "value": "GI",
    "dialCode": "350"
  },
  {
    "label": "Grèce",
    "value": "GR",
    "dialCode": "30"
  },
  {
    "label": "Grenade",
    "value": "GD",
    "dialCode": "1"
  },
  {
    "label": "Groenland",
    "value": "GL",
    "dialCode": "299"
  },
  {
    "label": "Guadeloupe",
    "value": "GP",
    "dialCode": "590"
  },
  {
    "label": "Guam",
    "value": "GU",
    "dialCode": "1"
  },
  {
    "label": "Guatemala",
    "value": "GT",
    "dialCode": "502"
  },
  {
    "label": "Guernesey",
    "value": "GG",
    "dialCode": "44"
  },
  {
    "label": "Guinée",
    "value": "GN",
    "dialCode": "224"
  },
  {
    "label": "Guinée équatoriale",
    "value": "GQ",
    "dialCode": "240"
  },
  {
    "label": "Guinée-Bissau",
    "value": "GW",
    "dialCode": "245"
  },
  {
    "label": "Guyana",
    "value": "GY",
    "dialCode": "592"
  },
  {
    "label": "Guyane française",
    "value": "GF",
    "dialCode": "594"
  },
  {
    "label": "Haïti",
    "value": "HT",
    "dialCode": "509"
  },
  {
    "label": "Honduras",
    "value": "HN",
    "dialCode": "504"
  },
  {
    "label": "Hongrie",
    "value": "HU",
    "dialCode": "36"
  },
  {
    "label": "Île Bouvet",
    "value": "BV"
  },
  {
    "label": "Île Christmas",
    "value": "CX",
    "dialCode": "61"
  },
  {
    "label": "Île Clipperton",
    "value": "CP"
  },
  {
    "label": "Île de l'Ascension",
    "value": "AC",
    "dialCode": "247"
  },
  {
    "label": "Île de Man",
    "value": "IM",
    "dialCode": "44"
  },
  {
    "label": "Île Norfolk",
    "value": "NF",
    "dialCode": "672"
  },
  {
    "label": "Îles Åland",
    "value": "AX",
    "dialCode": "358"
  },
  {
    "label": "Îles Caïmans",
    "value": "KY",
    "dialCode": "1"
  },
  {
    "label": "Îles Canaries",
    "value": "IC"
  },
  {
    "label": "Îles Cocos - Keeling",
    "value": "CC",
    "dialCode": "61"
  },
  {
    "label": "Îles Cook",
    "value": "CK",
    "dialCode": "682"
  },
  {
    "label": "Îles Féroé",
    "value": "FO",
    "dialCode": "298"
  },
  {
    "label": "Îles Heard et MacDonald",
    "value": "HM"
  },
  {
    "label": "Îles Malouines",
    "value": "FK",
    "dialCode": "500"
  },
  {
    "label": "Îles Mariannes du Nord",
    "value": "MP",
    "dialCode": "1"
  },
  {
    "label": "Îles Marshall",
    "value": "MH",
    "dialCode": "692"
  },
  {
    "label": "Îles Mineures Éloignées des États-Unis",
    "value": "UM"
  },
  {
    "label": "Îles Salomon",
    "value": "SB",
    "dialCode": "677"
  },
  {
    "label": "Îles Turks et Caïques",
    "value": "TC",
    "dialCode": "1"
  },
  {
    "label": "Îles Vierges britanniques",
    "value": "VG",
    "dialCode": "1"
  },
  {
    "label": "Îles Vierges des États-Unis",
    "value": "VI",
    "dialCode": "1"
  },
  {
    "label": "Inde",
    "value": "IN",
    "dialCode": "91"
  },
  {
    "label": "Indonésie",
    "value": "ID",
    "dialCode": "62"
  },
  {
    "label": "Irak",
    "value": "IQ",
    "dialCode": "964"
  },
  {
    "label": "Iran",
    "value": "IR",
    "dialCode": "98"
  },
  {
    "label": "Irlande",
    "value": "IE",
    "dialCode": "353"
  },
  {
    "label": "Islande",
    "value": "IS",
    "dialCode": "354"
  },
  {
    "label": "Israël",
    "value": "IL",
    "dialCode": "972"
  },
  {
    "label": "Italie",
    "value": "IT",
    "dialCode": "39"
  },
  {
    "label": "Jamaïque",
    "value": "JM",
    "dialCode": "1"
  },
  {
    "label": "Japon",
    "value": "JP",
    "dialCode": "81"
  },
  {
    "label": "Jersey",
    "value": "JE",
    "dialCode": "44"
  },
  {
    "label": "Jordanie",
    "value": "JO",
    "dialCode": "962"
  },
  {
    "label": "Kazakhstan",
    "value": "KZ",
    "dialCode": "7"
  },
  {
    "label": "Kenya",
    "value": "KE",
    "dialCode": "254"
  },
  {
    "label": "Kirghizistan",
    "value": "KG",
    "dialCode": "996"
  },
  {
    "label": "Kiribati",
    "value": "KI",
    "dialCode": "686"
  },
  {
    "label": "Koweït",
    "value": "KW",
    "dialCode": "965"
  },
  {
    "label": "Laos",
    "value": "LA",
    "dialCode": "856"
  },
  {
    "label": "Lesotho",
    "value": "LS",
    "dialCode": "266"
  },
  {
    "label": "Lettonie",
    "value": "LV",
    "dialCode": "371"
  },
  {
    "label": "Liban",
    "value": "LB",
    "dialCode": "961"
  },
  {
    "label": "Libéria",
    "value": "LR",
    "dialCode": "231"
  },
  {
    "label": "Libye",
    "value": "LY",
    "dialCode": "218"
  },
  {
    "label": "Liechtenstein",
    "value": "LI",
    "dialCode": "423"
  },
  {
    "label": "Lituanie",
    "value": "LT",
    "dialCode": "370"
  },
  {
    "label": "Luxembourg",
    "value": "LU",
    "dialCode": "352"
  },
  {
    "label": "Macédoine",
    "value": "MK",
    "dialCode": "389"
  },
  {
    "label": "Madagascar",
    "value": "MG",
    "dialCode": "261"
  },
  {
    "label": "Malaisie",
    "value": "MY",
    "dialCode": "60"
  },
  {
    "label": "Malawi",
    "value": "MW",
    "dialCode": "265"
  },
  {
    "label": "Maldives",
    "value": "MV",
    "dialCode": "960"
  },
  {
    "label": "Mali",
    "value": "ML",
    "dialCode": "223"
  },
  {
    "label": "Malte",
    "value": "MT",
    "dialCode": "356"
  },
  {
    "label": "Maroc",
    "value": "MA",
    "dialCode": "212"
  },
  {
    "label": "Martinique",
    "value": "MQ",
    "dialCode": "596"
  },
  {
    "label": "Maurice",
    "value": "MU",
    "dialCode": "230"
  },
  {
    "label": "Mauritanie",
    "value": "MR",
    "dialCode": "222"
  },
  {
    "label": "Mayotte",
    "value": "YT",
    "dialCode": "262"
  },
  {
    "label": "Mexique",
    "value": "MX",
    "dialCode": "52"
  },
  {
    "label": "Moldavie",
    "value": "MD",
    "dialCode": "373"
  },
  {
    "label": "Monaco",
    "value": "MC",
    "dialCode": "377"
  },
  {
    "label": "Mongolie",
    "value": "MN",
    "dialCode": "976"
  },
  {
    "label": "Monténégro",
    "value": "ME",
    "dialCode": "382"
  },
  {
    "label": "Montserrat",
    "value": "MS",
    "dialCode": "1"
  },
  {
    "label": "Mozambique",
    "value": "MZ",
    "dialCode": "258"
  },
  {
    "label": "Myanmar",
    "value": "MM",
    "dialCode": "95"
  },
  {
    "label": "Namibie",
    "value": "NA",
    "dialCode": "264"
  },
  {
    "label": "Nauru",
    "value": "NR",
    "dialCode": "674"
  },
  {
    "label": "Népal",
    "value": "NP",
    "dialCode": "977"
  },
  {
    "label": "Nicaragua",
    "value": "NI",
    "dialCode": "505"
  },
  {
    "label": "Niger",
    "value": "NE",
    "dialCode": "227"
  },
  {
    "label": "Nigéria",
    "value": "NG",
    "dialCode": "234"
  },
  {
    "label": "Niue",
    "value": "NU",
    "dialCode": "683"
  },
  {
    "label": "Norvège",
    "value": "NO",
    "dialCode": "47"
  },
  {
    "label": "Nouvelle-Calédonie",
    "value": "NC",
    "dialCode": "687"
  },
  {
    "label": "Nouvelle-Zélande",
    "value": "NZ",
    "dialCode": "64"
  },
  {
    "label": "Oman",
    "value": "OM",
    "dialCode": "968"
  },
  {
    "label": "Ouganda",
    "value": "UG",
    "dialCode": "256"
  },
  {
    "label": "Ouzbékistan",
    "value": "UZ",
    "dialCode": "998"
  },
  {
    "label": "Pakistan",
    "value": "PK",
    "dialCode": "92"
  },
  {
    "label": "Palaos",
    "value": "PW",
    "dialCode": "680"
  },
  {
    "label": "Panama",
    "value": "PA",
    "dialCode": "507"
  },
  {
    "label": "Papouasie-Nouvelle-Guinée",
    "value": "PG",
    "dialCode": "675"
  },
  {
    "label": "Paraguay",
    "value": "PY",
    "dialCode": "595"
  },
  {
    "label": "Pays-Bas",
    "value": "NL",
    "dialCode": "31"
  },
  {
    "label": "Pérou",
    "value": "PE",
    "dialCode": "51"
  },
  {
    "label": "Philippines",
    "value": "PH",
    "dialCode": "63"
  },
  {
    "label": "Pitcairn",
    "value": "PN"
  },
  {
    "label": "Pologne",
    "value": "PL",
    "dialCode": "48"
  },
  {
    "label": "Polynésie française",
    "value": "PF",
    "dialCode": "689"
  },
  {
    "label": "Porto Rico",
    "value": "PR",
    "dialCode": "1"
  },
  {
    "label": "Portugal",
    "value": "PT",
    "dialCode": "351"
  },
  {
    "label": "Qatar",
    "value": "QA",
    "dialCode": "974"
  },
  {
    "label": "R.A.S. chinoise de Hong Kong",
    "value": "HK",
    "dialCode": "852"
  },
  {
    "label": "R.A.S. chinoise de Macao",
    "value": "MO",
    "dialCode": "853"
  },
  {
    "label": "régions éloignées de l’Océanie",
    "value": "QO"
  },
  {
    "label": "République centrafricaine",
    "value": "CF",
    "dialCode": "236"
  },
  {
    "label": "République démocratique du Congo",
    "value": "CD",
    "dialCode": "243"
  },
  {
    "label": "République dominicaine",
    "value": "DO",
    "dialCode": "1"
  },
  {
    "label": "République tchèque",
    "value": "CZ",
    "dialCode": "420"
  },
  {
    "label": "Réunion",
    "value": "RE",
    "dialCode": "262"
  },
  {
    "label": "Roumanie",
    "value": "RO",
    "dialCode": "40"
  },
  {
    "label": "Royaume-Uni",
    "value": "GB",
    "dialCode": "44"
  },
  {
    "label": "Russie",
    "value": "RU",
    "dialCode": "7"
  },
  {
    "label": "Rwanda",
    "value": "RW",
    "dialCode": "250"
  },
  {
    "label": "Sahara occidental",
    "value": "EH",
    "dialCode": "212"
  },
  {
    "label": "Saint-Barthélémy",
    "value": "BL",
    "dialCode": "590"
  },
  {
    "label": "Saint-Kitts-et-Nevis",
    "value": "KN",
    "dialCode": "1"
  },
  {
    "label": "Saint-Marin",
    "value": "SM",
    "dialCode": "378"
  },
  {
    "label": "Saint-Martin",
    "value": "MF",
    "dialCode": "590"
  },
  {
    "label": "Saint-Pierre-et-Miquelon",
    "value": "PM",
    "dialCode": "508"
  },
  {
    "label": "Saint-Vincent-et-les Grenadines",
    "value": "VC",
    "dialCode": "1"
  },
  {
    "label": "Sainte-Hélène",
    "value": "SH",
    "dialCode": "290"
  },
  {
    "label": "Sainte-Lucie",
    "value": "LC",
    "dialCode": "1"
  },
  {
    "label": "Samoa",
    "value": "WS",
    "dialCode": "685"
  },
  {
    "label": "Samoa américaines",
    "value": "AS",
    "dialCode": "1"
  },
  {
    "label": "Sao Tomé-et-Principe",
    "value": "ST",
    "dialCode": "239"
  },
  {
    "label": "Sénégal",
    "value": "SN",
    "dialCode": "221"
  },
  {
    "label": "Serbie",
    "value": "RS",
    "dialCode": "381"
  },
  {
    "label": "Serbie-et-Monténégro",
    "value": "CS"
  },
  {
    "label": "Seychelles",
    "value": "SC",
    "dialCode": "248"
  },
  {
    "label": "Sierra Leone",
    "value": "SL",
    "dialCode": "232"
  },
  {
    "label": "Singapour",
    "value": "SG",
    "dialCode": "65"
  },
  {
    "label": "Slovaquie",
    "value": "SK",
    "dialCode": "421"
  },
  {
    "label": "Slovénie",
    "value": "SI",
    "dialCode": "386"
  },
  {
    "label": "Somalie",
    "value": "SO",
    "dialCode": "252"
  },
  {
    "label": "Soudan",
    "value": "SD",
    "dialCode": "249"
  },
  {
    "label": "Sri Lanka",
    "value": "LK",
    "dialCode": "94"
  },
  {
    "label": "Suède",
    "value": "SE",
    "dialCode": "46"
  },
  {
    "label": "Suisse",
    "value": "CH",
    "dialCode": "41"
  },
  {
    "label": "Suriname",
    "value": "SR",
    "dialCode": "597"
  },
  {
    "label": "Svalbard et Île Jan Mayen",
    "value": "SJ",
    "dialCode": "47"
  },
  {
    "label": "Swaziland",
    "value": "SZ",
    "dialCode": "268"
  },
  {
    "label": "Syrie",
    "value": "SY",
    "dialCode": "963"
  },
  {
    "label": "Tadjikistan",
    "value": "TJ",
    "dialCode": "992"
  },
  {
    "label": "Taïwan",
    "value": "TW",
    "dialCode": "886"
  },
  {
    "label": "Tanzanie",
    "value": "TZ",
    "dialCode": "255"
  },
  {
    "label": "Tchad",
    "value": "TD",
    "dialCode": "235"
  },
  {
    "label": "Terres australes françaises",
    "value": "TF"
  },
  {
    "label": "Territoire britannique de l'océan Indien",
    "value": "IO",
    "dialCode": "246"
  },
  {
    "label": "Territoire palestinien",
    "value": "PS",
    "dialCode": "970"
  },
  {
    "label": "Thaïlande",
    "value": "TH",
    "dialCode": "66"
  },
  {
    "label": "Timor oriental",
    "value": "TL",
    "dialCode": "670"
  },
  {
    "label": "Togo",
    "value": "TG",
    "dialCode": "228"
  },
  {
    "label": "Tokelau",
    "value": "TK",
    "dialCode": "690"
  },
  {
    "label": "Tonga",
    "value": "TO",
    "dialCode": "676"
  },
  {
    "label": "Trinité-et-Tobago",
    "value": "TT",
    "dialCode": "1"
  },
  {
    "label": "Tristan da Cunha",
    "value": "TA",
    "dialCode": "290"
  },
  {
    "label": "Tunisie",
    "value": "TN",
    "dialCode": "216"
  },
  {
    "label": "Turkménistan",
    "value": "TM",
    "dialCode": "993"
  },
  {
    "label": "Turquie",
    "value": "TR",
    "dialCode": "90"
  },
  {
    "label": "Tuvalu",
    "value": "TV",
    "dialCode": "688"
  },
  {
    "label": "Ukraine",
    "value": "UA",
    "dialCode": "380"
  },
  {
    "label": "Union européenne",
    "value": "EU"
  },
  {
    "label": "Uruguay",
    "value": "UY",
    "dialCode": "598"
  },
  {
    "label": "Vanuatu",
    "value": "VU",
    "dialCode": "678"
  },
  {
    "label": "Venezuela",
    "value": "VE",
    "dialCode": "58"
  },
  {
    "label": "Viêt Nam",
    "value": "VN",
    "dialCode": "84"
  },
  {
    "label": "Wallis-et-Futuna",
    "value": "WF",
    "dialCode": "681"
  },
  {
    "label": "Yémen",
    "value": "YE",
    "dialCode": "967"
  },
  {
    "label": "Zambie",
    "value": "ZM",
    "dialCode": "260"
  },
  {
    "label": "Zimbabwe",
    "value": "ZW",
    "dialCode": "263"
  }
]

export function countryCodeToFlagEmoji(code) {
  if (!code || typeof code !== "string") return "";

  const cc = code.trim().toUpperCase();

  if (cc.length !== 2 || /[^A-Z]/.test(cc)) return "";

  const REGIONAL_INDICATOR_A = 0x1F1E6; // 🇦
  return String.fromCodePoint(
    ...[...cc].map(ch => REGIONAL_INDICATOR_A + (ch.codePointAt(0) - 0x41))
  );
}